import React, { useState, useEffect } from 'react';

const PrettyJSON = ({ object }) => {

    const jsonString = object ;
    const [jsonObject, setJsonObject] = useState({});
  
    useEffect(() => {
      try {
        const parsedObject = JSON.parse(jsonString);
        setJsonObject(parsedObject);
      } catch (error) {
        console.error("Invalid JSON string", error);
      }
    }, []);
  
    return (
        <pre>{JSON.stringify(jsonObject, null, 2)}</pre>
    );
  }
  
  export default PrettyJSON;